import { render, staticRenderFns } from "./VideoMaterialCard.vue?vue&type=template&id=02893c9e&scoped=true"
import script from "./VideoMaterialCard.vue?vue&type=script&lang=js"
export * from "./VideoMaterialCard.vue?vue&type=script&lang=js"
import style0 from "./VideoMaterialCard.vue?vue&type=style&index=0&id=02893c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02893c9e",
  null
  
)

export default component.exports